import { reactive } from 'vue';
function createInitialState() {
    const now = new Date();
    return {
        appVersion: '',
        useCache: localStorage.getItem('showHiddenSettings') !== 'true' || localStorage.getItem('useLocalCache') !== 'false',
        useCachedEndpoints: localStorage.getItem('showHiddenSettings') !== 'true' || localStorage.getItem('useCachedEndpoints') !== 'false',
        cachedBlacklist: ["/VerifiedEmails/", "/logo", "/Documents/", "/Achievements/Points", "/Achievements", "/Quizzes", "/Chats/Messages", "/CMS", "/Payments", "/Vouchers", "/Questionnaires"],
        api: null,
        configUri: null,
        customer: null,
        customerTags: [],
        customerTagTransactions: [],
        employer: null,
        bankInfo: null,
        bankAccount: null,
        insuranceInfo: null,
        insuranceProviders: null,
        investmentProviders: null,
        mortgageInfo: null,
        investmentInfo: null,
        creditInfo: null,
        documents: null,
        investmentAccount: null,
        articles: null,
        article: null,
        disabledFeatures: [],
        enabledFeatures: [],
        spendingAnalysis: null,
        spendingAnalysisStructured: null,
        spendingPlans: null,
        spendingPlansFull: null,
        availableVouchers: null,
        availableVoucher: null,
        favouriteDiscounts: null,
        vouchers: null,
        groupedVouchers: null,
        vouchersSummary: null,
        voucher: null,
        categories: [],
        creditTypes: [],
        creditProviders: [],
        plans: null,
        plan: null,
        planSection: null,
        planTask: null,
        products: [],
        marketplace: [],
        benefits: [],
        calculators: [],
        notifications: null,
        payment: null,
        policyTypes: [],
        savingGoals: null,
        investmentTypes: [],
        financialFitness: null,
        financialFitnessHistory: null,
        config: null,
        token: null,
        completedMoves: null,
        pendingMoves: null,
        customerMove: null,
        transaction: null,
        transactionClassifications: null,
        suggestedClassification: null,
        transactions: [],
        questionnaire: null,
        questionnaireAnswers: null,
        quizzes: null,
        quizPoints: null,
        quizAnswers: null,
        policy: null,
        creditAccount: null,
        randomiseFigures: false,
        isDarkMode: localStorage.getItem('showHiddenSettings') === 'true' && localStorage.getItem('mobileDarkMode') === 'true',
        points: null,
        sectionJson: null,
        faqs: null,
        formatter: {
            original: new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
            }),
            format(value, short = false, trailingZeroDisplay = true) {
                if (this.randomiseFigures == undefined || this.randomiseFigures == null) {
                    this.randomiseFigures = localStorage.getItem('randomiseFigures') === 'true';
                }
                if (this.randomiseFigures) {
                    return short ? "£#" : "£####";
                }
                const options = { style: 'currency', currency: 'GBP' };
                if (trailingZeroDisplay !== undefined) {
                    options.trailingZeroDisplay = trailingZeroDisplay ? 'auto' : 'stripIfInteger';
                }
                return new Intl.NumberFormat('en-GB', options).format(value);
            },
        },
        dateFormatPretty: new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }),
        timeOfDay: now.getHours() < 12 ? 'Morning' : now.getHours() < 18 ? 'Afternoon' : 'Evening',
        today: now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
        yesterday: new Date(now.setDate(now.getDate() - 1)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
        menuShown: false,
        bottomMenuHeight: 76,
        drawerBottom: -23,
        aiopSectionsS3Bucket: "https://s3.eu-west-2.amazonaws.com/aiop-configs.sysodev.link/",
        aiopSections: null,
        systemStatus: null,
        payslipsTab: 'pay',
        payslipsMonth: null,
        payslipsExpanded: {},
        payslipsListOpen: false,
        documentTab: null,
    };
}
// Module-scope singleton — shared across all components
const state = reactive(createInitialState());
export function useAppState() {
    return state;
}
